/**
 * @file オプションページのタイトル情報を管理するステート
 *
 * オプション申込・解約画面のヘッダーやパンくずリストに表示する
 * オプション名・コード・クラス種別を保持する。
 * オプション選択時にセットされ、画面遷移先で参照される。
 * セッションストレージに永続化される。
 */
import { atom } from 'recoil';
import persistAtom from './recoilPersist';

/** オプションページタイトルの型 */
export type PageTitle = {
  /** オプション表示名 */
  optionTitle: string;
  /** オプションコード */
  optionCode: string;
  /** オプションクラス種別（任意） */
  optionClassType?: string;
};

export const optionPageTitleState = atom<PageTitle>({
  key: 'optionPageTitleState',
  default: {
    optionTitle: '',
    optionCode: '',
    optionClassType: undefined,
  },
  effects_UNSTABLE: [persistAtom],
});

export default optionPageTitleState;
